import { render, staticRenderFns } from "./AlertMenu.vue?vue&type=template&id=45cb636a&scoped=true&"
import script from "./AlertMenu.vue?vue&type=script&lang=js&"
export * from "./AlertMenu.vue?vue&type=script&lang=js&"
import style0 from "./AlertMenu.vue?vue&type=style&index=0&id=45cb636a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb636a",
  null
  
)

export default component.exports